import TagControl from "./TagControl";
import {connect} from "react-redux";

/**
 * HOC that includes snippet CRUD functions for SnippetList component.
 *
 * @param snippetDuck the snippet duck
 */
const withSnippetFunctions = (snippetDuck) => (Component) => {
  const mapDispatchToProps = (dispatch) => ({
    destroy: (item) => dispatch(snippetDuck.actions.remove(item)).then(() => dispatch(snippetDuck.actions.markDirty())),
    load: (id) => dispatch(snippetDuck.actions.get(id)),
    loadAll: () => dispatch(snippetDuck.actions.load()),
    save: (item) => dispatch(snippetDuck.actions.save(item)).then(() => dispatch(snippetDuck.actions.markDirty())),
  });

  return connect(null, mapDispatchToProps)(Component);
};

/**
 * Tag field definition for <SnippetEditor/>.
 */
const tagEditorField = {
  displayName: 'Tags',
  canonicalName: 'tag_names',
  control: TagControl,
  optional: true,
  condition: (snippet) => !snippet.standard
};

export {tagEditorField, withSnippetFunctions};
